{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-210100",
  "definition": "[210100] Sub-classification of assets, liabilities and equity, by current/non-current method",
  "sheetId": "SubClassificationOfAssetsLiabilitiesEquity",
  "label": "Sub-classification of Assets, Liabilities and Equity (MFRS)",
  "taxonomy": "FS-MFRS",
  "controls": [
    {
      "qname": "ssmt-mfrs:DisclosureOnSubclassificationOfAssetsLiabilitiesAndEquityAbstract",
      "label": "Statement on sub-classification of assets, liabilities and equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:SubclassificationOfAssetsLiabilitiesAndEquityAbstract",
      "label": "Sub-classification of assets, liabilities and equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:PropertyPlantAndEquipmentAbstract",
      "label": "Property, Plant and Equipment",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LandAndBuildingsAbstract",
      "label": "Land and buildings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:LandAbstract",
      "label": "Land",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:FreeholdLand",
      "label": "Freehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:LongtermLeaseholdLand",
      "label": "Long term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ShorttermLeaseholdLand",
      "label": "Short term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Land",
      "label": "Total land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true,
        "sectionBoundary": 5
      }
    },
    {
      "qname": "ssmt-mfrs:BuildingAbstract",
      "label": "Buildings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BuildingOnFreeholdLand",
      "label": "Building on freehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BuildingOnLongtermLeaseholdLand",
      "label": "Building on long term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BuildingOnShorttermLeaseholdLand",
      "label": "Building on short term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:LeasedProperties",
      "label": "Leased properties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Buildings",
      "label": "Total buildings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LandAndBuildings",
      "label": "Total land and buildings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true,
        "sectionBoundary": 4
      }
    },
    {
      "qname": "ifrs-full:VehiclesAbstract",
      "label": "Vehicles",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:Vessels",
      "label": "Vessels",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Aircraft",
      "label": "Aircraft",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:MotorVehicles",
      "label": "Motor vehicles",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherVehicles",
      "label": "Other vehicles",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Vehicles",
      "label": "Total vehicles",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true,
        "sectionBoundary": 4
      }
    },
    {
      "qname": "ifrs-full:Machinery",
      "label": "Machinery",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:PlantAndEquipment",
      "label": "Plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OfficeEquipmentFixtureAndFittings",
      "label": "Office equipment, fixture and fittings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ComputerSoftwareAndHardware",
      "label": "Computer software and hardware",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:BearerPlants",
      "label": "Bearer plants",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InfrastructureAndSiteFacilities",
      "label": "Infrastructure and site facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:MiningAssets",
      "label": "Mining assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OilAndGasAssets",
      "label": "Oil and gas assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:TangibleExplorationAndEvaluationAssets",
      "label": "Tangible exploration and evaluation assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:TelecommunicationEquipments",
      "label": "Telecommunication equipments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ConstructionInProgress",
      "label": "Construction in progress/Asset work-in progress",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherPropertyPlantAndEquipment",
      "label": "Other property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:PropertyPlantAndEquipment",
      "required": true,
      "label": "Total property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true,
        "sectionBoundary": 3
      }
    },
    {
      "qname": "ifrs-full:InvestmentPropertyAbstract",
      "label": "Investment Property",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentPropertyCompletedAbstract",
      "label": "Investment properties completed, at carrying value",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentPropertyFreeholdLandAndBuilding",
      "label": "Freehold land and building",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentPropertyLeaseholdLandAndBuilding",
      "label": "Leasehold land and building",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentPropertyCompleted",
      "label": "Total investment properties completed, at carrying value",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentPropertyUnderConstructionOrDevelopmentAbstract",
      "label": "Investment properties under construction or development, at cost",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentPropertyBuildingUnderConstruction",
      "label": "Building under construction",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentPropertyUnderConstructionOrDevelopment",
      "label": "Total investment properties under construction or development, at cost",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherInvestmentProperty",
      "label": "Other investment property",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentProperty",
      "required": true,
      "label": "Total investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BiologicalAssetsAbstract",
      "label": "Biological Assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ConsumableBiologicalAssets",
      "label": "Consumable biological assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BearerBiologicalAssets",
      "label": "Bearer biological assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:BiologicalAssets",
      "label": "Total biological assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ssmt-mfrs:CurrentBiologicalAssets",
            "operation": "sum",
            "message": "Total Biological Asset should be the Sum of both Biological Assets under Statement of Financial Position."
          },
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ssmt-mfrs:NoncurrentBiologicalAssets",
            "operation": "sum"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:IntangibleAssetsAndGoodwillAbstract",
      "label": "Intangible assets and goodwill",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IntangibleAssetsOtherThanGoodwillAbstract",
      "label": "Intangible assets other than goodwill",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CustomerrelatedIntangibleAssetsRecognisedAsOfAcquisitionDate",
      "label": "Customer acquisition costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:BrandNames",
      "label": "Brand names",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CustomerRelationships",
      "label": "Customer relationships",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CopyrightsPatentsAndOtherIndustrialPropertyRightsServiceAndOperatingRights",
      "label": "Copyrights, patents and other industrial property rights, service and operating rights",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IntangibleAssetsUnderDevelopment",
      "label": "Intangible assets under development",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IntangibleExplorationAndEvaluationAssets",
      "label": "Intangible exploration and evaluation assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LicencesAndFranchises",
      "label": "Licences and franchises",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RecipesFormulaeModelsDesignsAndPrototypes",
      "label": "Recipes, formulae, models, designs and prototypes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ComputerSoftware",
      "label": "Computer software",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:SmallHolderRelationship",
      "label": "Small holder relationship",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherIntangibleAssets",
      "label": "Other intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IntangibleAssetsOtherThanGoodwill",
      "label": "Total intangible assets other than goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Goodwill",
      "label": "Goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IntangibleAssetsAndGoodwill",
      "required": true,
      "label": "Total intangible assets and goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInSubsidiariesAbstract",
      "label": "Investments in subsidiaries",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInSubsidiariesUnquotedSharesInMalaysiaNetOfImpairmentLosses",
      "label": "Unquoted shares, net of impairment losses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInSubsidiariesQuotedSharesInMalaysia",
      "label": "Quoted shares in Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInSubsidiariesQuotedSharesOutsideMalaysia",
      "label": "Quoted shares outside Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInSubsidiariesFairValueAdjustmentsOnLoansAndAdvancesAndFinancialGuarantee",
      "label": "Fair value adjustments on loans and advances and financial guarantee",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ContributionsToSubsidiariesNetOfImpairmentLosses",
      "label": "Contributions to subsidiaries, net of impairment losses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentsInSubsidiariesOtherInvestmentsNetOfImpairmentLosses",
      "label": "Other investments in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInSubsidiaries",
      "required": true,
      "label": "Total investments in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInAssociatesAbstract",
      "label": "Investments in associates",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInAssociatesUnquotedSharesInMalaysiaNetOfImpairmentLosses",
      "label": "Unquoted shares, net of impairment losses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInAssociatesQuotedSharesInMalaysia",
      "label": "Quoted shares in Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInAssociatesQuotedSharesOutsideMalaysia",
      "label": "Quoted shares outside Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInAssociatesFairValueAdjustmentsOnLoansAndAdvancesAndFinancialGuarantee",
      "label": "Fair value adjustments on loans and advances and financial guarantee",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentsInAssociatesShareOfPostAcquisitionProfitsAndReserves",
      "label": "Share of post-acquisition profits and reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInAssociatesUnrealisedProfitOnTransactionsWithAssociates",
      "label": "Unrealised profit on transactions with associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentsInAssociatesOtherInvestmentsNetOfImpairmentLosses",
      "label": "Other investments in associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInAssociates",
      "required": true,
      "label": "Total investments in associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInJointVenturesAbstract",
      "label": "Investments in joint ventures",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInJointVenturesUnquotedSharesInMalaysiaNetOfImpairmentLosses",
      "label": "Unquoted shares, net of impairment losses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInJointVenturesQuotedSharesInMalaysia",
      "label": "Quoted shares in Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInJointVenturesQuotedSharesOutsideMalaysia",
      "label": "Quoted shares outside Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentInJointVenturesFairValueAdjustmentsOnLoansAdvancesAndFinancialGuarantee",
      "label": "Fair value adjustments on loans and advances and financial guarantee",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentsInJointVentureShareOfPostAcquisitionProfitsAndReserves",
      "label": "Share of post-acquisition profits and reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentsInJointVentureUnrealisedProfitOnTransactionsWithJointVentures",
      "label": "Unrealised profit on transactions with joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InvestmentsInJointVentureOtherInvestment",
      "label": "Other investments in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInJointVentures",
      "required": true,
      "label": "Total investments in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:TradeAndOtherNoncurrentReceivablesAbstract",
      "label": "Trade and other non-current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentTradeReceivablesAbstract",
      "label": "Non-current trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradeReceivablesDueFromCustomers",
      "label": "Trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradeReceivablesDueFromHoldingCompany",
      "label": "Trade receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradeReceivablesDueFromSubsidiaries",
      "label": "Trade receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradeReceivablesDueFromAssociates",
      "label": "Trade receivables from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradeReceivablesDueFromJointVentures",
      "label": "Trade receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradeReceivablesDueFromRelatedParties",
      "label": "Trade receivables due from other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentTradeReceivables",
      "label": "Other non-current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentTradeReceivables",
      "label": "Total non-current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentReceivablesAbstract",
      "label": "Other non-current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentReceivablesDueFromRelatedPartiesAbstract",
      "label": "Other non-current receivables due from related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentReceivablesDueFromHoldingCompany",
      "label": "Other receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentReceivablesDueFromSubsidiaries",
      "label": "Other receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentReceivablesDueFromAssociates",
      "label": "Other receivables due from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentReceivablesDueFromJointVentures",
      "label": "Other receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:MiscellaneousOtherNoncurrentReceivablesDueFromRelatedCompanies",
      "label": "Other receivables due from other related companies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentReceivablesDueFromRelatedParties",
      "label": "Total other non-current receivables due from related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentNontradeReceivablesAbstract",
      "label": "Non-current non-trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentNontradePrepaymentAndAccruedIncome",
      "label": "Accrued income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentNontradeLeaseAndHirePurchaseReceivables",
      "label": "Lease and hire purchase receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentNontradeMiscellaneous",
      "label": "Other non-current non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentNontradeReceivables",
      "label": "Total non-current non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherNoncurrentReceivables",
      "label": "Total other non-current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentReceivables",
      "required": true,
      "label": "Total trade and other non-current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativeFinancialAssetsAbstract",
      "label": "Non-current derivative financial assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativesAtFairValueThroughProfitOrLossAbstract",
      "label": "Non-current derivatives at fair value through profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialAssetsForwardContract",
      "label": "Forward contract",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialAssetsOptions",
      "label": "Options",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialAssetsSwaps",
      "label": "Swap",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentOtherDerivativeFinancialAssetsAtFairValueThroughProfitOrLoss",
      "label": "Other derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialAssetsAtFairValueThroughProfitOrLoss",
      "label": "Total non-current derivatives at fair value through profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialAssetsOthers",
      "label": "Other non-current derivative financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativeFinancialAssets",
      "required": true,
      "label": "Total non-current derivative financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InventoriesAbstract",
      "label": "Inventories",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RawMaterials",
      "label": "Raw materials",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:WorkInProgress",
      "label": "Work in progress",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:FinishedGoods",
      "label": "Finished goods",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:SpareParts",
      "label": "Spare parts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherInventories",
      "label": "Other inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InventoriesTotal",
      "required": true,
      "label": "Total inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:TradeAndOtherCurrentReceivablesAbstract",
      "label": "Trade and other current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesAbstract",
      "label": "Current trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesDueFromCustomers",
      "label": "Trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesDueFromContractCustomers",
      "label": "Trade receivables due from contract customers",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesDueFromHoldingCompany",
      "label": "Trade receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesDueFromSubsidiaries",
      "label": "Trade receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesDueFromAssociates",
      "label": "Trade receivables due from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesDueFromJointVentures",
      "label": "Trade receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradeReceivablesDueFromRelatedParties",
      "label": "Trade receivables due from other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:TradeReceivablesUnearnedCurrentCarryingCharges",
      "label": "Unearned current carrying charges",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentTradeReceivables",
      "label": "Other current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentTradeReceivables",
      "label": "Total current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesAbstract",
      "label": "Other current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesDueFromRelatedPartiesAbstract",
      "label": "Other current receivables due from related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesDueFromHoldingCompany",
      "label": "Other receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesDueFromSubsidiaries",
      "label": "Other receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesDueFromAssociates",
      "label": "Other receivables due from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesDueFromJointVentures",
      "label": "Other receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesDueFromOtherRelatedParties",
      "label": "Other receivables due from other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentReceivablesDueFromRelatedParties",
      "label": "Total other current receivables due from related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPrepaymentsAndCurrentAccruedIncomeAbstract",
      "label": "Current prepayments and current accrued income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPrepayments",
      "label": "Prepayments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentAccruedIncome",
      "label": "Accrued income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPrepaymentsAndCurrentAccruedIncome",
      "label": "Total current prepayments and current accrued income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeReceivablesAbstract",
      "label": "Current non-trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentNontradeFinanceIncomeReceivable",
      "label": "Interest receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentNontradeDeposits",
      "label": "Deposits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentNontradeDividendReceivables",
      "label": "Dividend receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentNontradeLeaseAndHirePurchaseReceivables",
      "label": "Lease and hire purchase receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentMiscellaneousNontradeReceivables",
      "label": "Other current non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentNontradeReceivables",
      "label": "Total current non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherCurrentReceivables",
      "label": "Total other current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:TradeAndOtherCurrentReceivables",
      "required": true,
      "label": "Total trade and other current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativeFinancialAssetsAbstract",
      "label": "Current derivative financial assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativesAtFairValueThroughProfitOrLossAbstract",
      "label": "Current derivatives at fair value through profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialAssetsForwardContract",
      "label": "Forward contract",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialAssetsOptions",
      "label": "Options",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialAssetsSwaps",
      "label": "Swap",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentOtherDerivativeFinancialAssetsAtFairValueThroughProfitOrLoss",
      "label": "Other derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialAssetsAtFairValueThroughProfitOrLoss",
      "label": "Total current derivatives at fair value through profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialAssetsOthers",
      "label": "Other current derivative financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativeFinancialAssets",
      "required": true,
      "label": "Total current derivative financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CashAndCashEquivalentsAbstract",
      "label": "Cash and cash equivalents",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CashAbstract",
      "label": "Cash",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CashOnHand",
      "label": "Cash in hand",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:BalancesWithBanks",
      "label": "Balances with Licensed Banks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Cash",
      "label": "Total cash",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CashEquivalentsAbstract",
      "label": "Cash equivalents",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:DepositsAndPlacementsWithLicensedBanks",
      "label": "Deposits placed with licensed banks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:DepositsPlacedWithOtherCorporations",
      "label": "Deposit placed with other corporations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CashEquivalentsWithOtherFinancialInstitutions",
      "label": "Cash equivalents with other financial institutions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermDepositsClassifiedAsCashEquivalents",
      "label": "Short-term deposits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermInvestmentsClassifiedAsCashEquivalents",
      "label": "Short-term investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:BankingArrangementsClassifiedAsCashEquivalents",
      "label": "Other banking arrangements",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CashEquivalents",
      "label": "Total cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherCashAndCashEquivalents",
      "label": "Other cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:CashAndBankBalances",
      "required": true,
      "label": "Total cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentAssetsAbstract",
      "label": "Other non-current assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:PrepaidRentalForBuildingAndFacilities",
      "label": "Prepaid rental of buildings and facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:PrepaidLandLease",
      "label": "Prepaid land lease",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:MiscellaneousOtherNoncurrentAssets",
      "label": "Other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherNoncurrentAssets",
      "label": "Total other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IssuedCapitalAbstract",
      "label": "Issued capital",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CapitalFromOrdinaryShares",
      "label": "Capital from ordinary shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CapitalFromRedeemablePreferenceShares",
      "label": "Capital from redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CapitalFromNonredeemablePreferenceShares",
      "label": "Capital from non-redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IssuedCapital",
      "required": true,
      "label": "Total issued capital",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ReservesAbstract",
      "label": "Reserves",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NondistributableReservesAbstract",
      "label": "Non-distributable",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CapitalReserve",
      "label": "Capital reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ReserveOfCashFlowHedges",
      "label": "Hedging reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ReserveOfExchangeDifferencesOnTranslation",
      "label": "Foreign currency translation reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ReserveOfSharebasedPayments",
      "label": "Reserve of share-based payments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevaluationSurplus",
      "label": "Revaluation surplus",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:StatutoryReserve",
      "label": "Statutory reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:WarrantReserve",
      "label": "Warrant reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNondistributableReserves",
      "label": "Other non-distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NondistributableReserves",
      "label": "Total non-distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:DistributableReservesAbstract",
      "label": "Distributable",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:FairValueReserves",
      "label": "Fair value reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ReserveOfNoncurrentAssetsClassifiedAsHeldForSale",
      "label": "Reserve of non-current assets classified as held for sale",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ConsolidatedReserve",
      "label": "Consolidation reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:WarrantyReserve",
      "label": "Warranty reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherDistributableReserve",
      "label": "Other distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:DistributableReserve",
      "label": "Total distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherReserves",
      "required": true,
      "label": "Total reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:EquityOtherComponentsAbstract",
      "label": "Equity - others components",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:PerpetualSukuk",
      "label": "Perpetual sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:EquityComponentOfIrredeemableConvertibleUnsecuredLoanStocks",
      "label": "Equity component of Irredeemable Convertible Unsecured Loan Stocks (ICULS)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:EquityComponentOfPreferenceShares",
      "label": "Equity component of preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:HeadOfficeAccounts",
      "label": "Head office accounts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:EquityComponentsOfOtherFinancialInstruments",
      "label": "Equity components of other financial instruments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherComponentsOfEquity",
      "required": true,
      "label": "Total equity - other components",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentBorrowingsAbstract",
      "label": "Non-current borrowings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfNoncurrentSecuredBankLoansReceivedAbstract",
      "label": "Non-current portion of non-current secured bank loans received",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredTermLoans",
      "label": "Term loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredIslamicFinancingFacilities",
      "label": "Islamic financing facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredHirePurchaseAndFinanceLeaseLiabilities",
      "label": "Hire purchase and finance lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredIslamicMediumTermNotes",
      "label": "Islamic medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredSukuk",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredRevolvingCreditAndOthers",
      "label": "Revolving credit and others",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentSecuredBankLoans",
      "label": "Other secured bank loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentPortionOfNoncurrentSecuredBankLoansReceived",
      "label": "Total non-current portion of non-current secured bank loans received",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfNoncurrentUnsecuredBankLoansReceivedAbstract",
      "label": "Non-current portion of non-current unsecured bank loans received",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredTermLoans",
      "label": "Term loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionofUnsecuredIrredeemableConvertibleUnsecuredLoanStocks",
      "label": "Irredeemable Convertible Unsecured Loan Stocks (ICULS)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredIslamicFinancingFacilities",
      "label": "Islamic financing facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredHirePurchaseAndFinanceLeaseLiabilities",
      "label": "Hire purchase and finance lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredIslamicMediumTermNotes",
      "label": "Islamic medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredSukuk",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredRevolvingCreditAndOthers",
      "label": "Revolving credit and others",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentUnsecuredBankLoans",
      "label": "Other unsecured bank loans received",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentPortionOfNoncurrentUnsecuredBankLoansReceived",
      "label": "Total non-current portion of non-current unsecured bank loans received",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredBondsSukukAndLoanStockAbstract",
      "label": "Non-current portion of secured bonds, sukuk and loan stock",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredBonds",
      "label": "Bonds",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredSukukAsPerShariahCommittee",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredMediumTermNotes",
      "label": "Medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredLoanStocks",
      "label": "Loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredPreferenceShares",
      "label": "Preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfSecuredBondsSukukAndLoanStock",
      "label": "Total non-current portion of secured bonds/sukuk/loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredBondsSukukAndLoanStockAbstract",
      "label": "Non-current portion of unsecured bonds, sukuk and loan stock",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredBonds",
      "label": "Bonds",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredSukukAsPerShariahCommittee",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredMediumTermNotes",
      "label": "Medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredLoanStocks",
      "label": "Loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredPreferenceShares",
      "label": "Preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentPortionOfUnsecuredBondsSukukAndLoanStock",
      "label": "Total non-current portion of unsecured bonds/sukuk/loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentBorrowingsAbstract",
      "label": "Other non-current borrowings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPortionOfLoanFromSubsidiaries",
      "label": "Loan from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPortionOfLoanFromAssociates",
      "label": "Loan from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPortionOfLoanFromJointVentures",
      "label": "Loan from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPortionOfRedeemablePreferenceShares",
      "label": "Redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPortionOfMiscellaneousBorrowings",
      "label": "Other non-current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentPortionOfOtherNoncurrentBorrowings",
      "label": "Total other non-current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LongtermBorrowings",
      "required": true,
      "label": "Total non-current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentEmployeeBenefitLiabilitiesAbstract",
      "label": "Non-current employee benefit liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentCashSettledShareBasedPaymentLiability",
      "label": "Cash-settled share-based payment liability",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentRetirementBenefits",
      "label": "Retirement benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentEmploymentTerminationBenefits",
      "label": "Employment termination benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentProvisionForConsumedLeave",
      "label": "Provision for unconsumed leave",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDefinedContributionPlan",
      "label": "Defined contribution plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDefinedBenefitPlan",
      "label": "Defined benefit plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentOtherEmployeeBenefitLiabilities",
      "label": "Other non-current employee benefit liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentProvisionsForEmployeeBenefits",
      "required": true,
      "label": "Total non-current employee benefit liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentProvisionsAbstract",
      "label": "Non-current provisions",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LongtermWarrantyProvision",
      "label": "Warranty provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LongtermRestructuringProvision",
      "label": "Restructuring provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LongtermLegalProceedingsProvision",
      "label": "Legal proceedings provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentRefundsProvision",
      "label": "Refund provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LongtermOnerousContractsProvision",
      "label": "Onerous contracts provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LongtermProvisionForDecommissioningRestorationAndRehabilitationCosts",
      "label": "Provision for decommissioning, restoration and rehabilitation costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherLongtermProvisions",
      "label": "Other non-current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentProvisions",
      "required": true,
      "label": "Total non-current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:TradeAndOtherNoncurrentPayablesAbstract",
      "label": "Trade and other non-current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradePayablesAbstract",
      "label": "Non-current trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradePayablesDueToCustomers",
      "label": "Trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradePayablesDueToHoldingCompany",
      "label": "Trade payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradePayablesDueToSubsidiaries",
      "label": "Trade payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradePayablesDueToAssociates",
      "label": "Trade payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradePayablesDueToJointVentures",
      "label": "Trade payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentTradePayablesDueToOtherRelatedParties",
      "label": "Trade payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentTradePayables",
      "label": "Other non-current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentPayablesToTradeSuppliers",
      "label": "Total non-current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPayablesAbstract",
      "label": "Other non-current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPayablesDueToRelatedPartiesAbstract",
      "label": "Other non-current payables due to related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentTradePayablesDueToHoldingCompany",
      "label": "Other payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentTradePayablesDueToSubsidiaries",
      "label": "Other payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentTradePayablesDueToAssociates",
      "label": "Other payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentTradePayablesDueToJointVentures",
      "label": "Other payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPayablesDueToRelatedCompanies",
      "label": "Other payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPayablesDueToRelatedParties",
      "label": "Total other non-current payables due to related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherPayablesDueToNoncontrollingInterestsAbstract",
      "label": "Other payables due to non-controlling interests",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentDividendPayablesDueToNoncontrollingInterests",
      "label": "Dividend payable to non-controlling interest",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentLoansFromNoncontrollingInterests",
      "label": "Loans from non-controlling interest",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentMiscellaneousPayablesDueToNoncontrollingInterests",
      "label": "Miscellaneous payables due to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentPayablesDueToNoncontrollingInterests",
      "label": "Total other payables due to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentNontradePayablesAbstract",
      "label": "Non-current non-trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentNontradeDeferredIncome",
      "label": "Deferred income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentNontradeAccruals",
      "label": "Accruals",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentNontradeRetentionPayables",
      "label": "Retention payable",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentNontradeDepositsAndAdvancedBillings",
      "label": "Deposits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentNontradePayables",
      "label": "Other non-current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentNontradePayables",
      "label": "Total non-current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherNoncurrentPayables",
      "label": "Other non-current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentPayables",
      "required": true,
      "label": "Total trade and other non-current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativeFinancialLiabilitiesAbstract",
      "label": "Non-current derivative financial liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativesAtFairValueThroughProfitOrLossAbstract",
      "label": "Non-current derivatives at fair value through profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesForwardContract",
      "label": "Forward contract",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesOptions",
      "label": "Options",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesSwaps",
      "label": "Swap",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesOtherDerivatives",
      "label": "Other derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesAtFairValueThroughProfitOrLoss",
      "label": "Total non-current derivatives at fair value through profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativesUsedForHedgingAbstract",
      "label": "Non-current derivatives used for hedging",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesForwardContractUsedForHedging",
      "label": "Forward contract",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitesOptionsUsedForHedging",
      "label": "Options",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesSwapUsedForHedging",
      "label": "Swap",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesOtherDerivativesUsedForHedging",
      "label": "Other derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentDerivativeFinancialLiabilitiesUsedForHedging",
      "label": "Total non-current derivatives used for hedging",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherNoncurrentDerivativeFinancialLiabilities",
      "label": "Other non-current derivative financial liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativeFinancialLiabilities",
      "required": true,
      "label": "Total non-current derivative financial liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentBorrowingsAbstract",
      "label": "Current borrowings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentSecuredBankLoansReceivedAndCurrentPortionAbstract",
      "label": "Current secured bank loans received and current portion of non-current secured bank loans received",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredBankersAcceptance",
      "label": "Bankers' acceptance",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredBankOverdrafts",
      "label": "Bank overdrafts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredTradeFinancingFacilities",
      "label": "Trade financing facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredTermLoans",
      "label": "Term loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredIslamicFinancingFacilities",
      "label": "Islamic financing facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredHirePurchaseAndFinanceLeaseLiabilities",
      "label": "Hire purchase and finance lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredIslamicMediumTermNotes",
      "label": "Islamic medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredSukuk",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredRevolvingCreditAndOthers",
      "label": "Revolving credit and others",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentSecuredOtherBankLoanReceived",
      "label": "Other secured bank loans received",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentSecuredBankLoansReceivedAndCurrentPortionOfNoncurrentSecuredBankLoansReceived",
      "label": "Total current secured bank loans received and current portion of non-current secured bank loans received",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentUnsecuredBankLoansReceivedAndCurrentPortionAbstract",
      "label": "Current unsecured bank loans received and current portion of non-current unsecured bank loans received",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredBlockDiscountingPayables",
      "label": "Block discounting payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredTermLoans",
      "label": "Term loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredIrredeemableConvertibleUnsecuredLoanStocks",
      "label": "Irredeemable convertible unsecured loan stocks (ICULS)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredIslamicFinancingFacilities",
      "label": "Islamic financing facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredHirePurchaseAndFinanceLeaseLiabilities",
      "label": "Hire purchase and finance lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredIslamicMediumTermNotes",
      "label": "Islamic medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredSukuk",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredRevolvingCreditAndOthers",
      "label": "Revolving credit and others",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfNoncurrentUnsecuredOtherBankLoansReceived",
      "label": "Other unsecured bank loans received",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentUnsecuredBankLoansReceivedAndCurrentPortionOfNoncurrentUnsecuredBankLoansReceived",
      "label": "Total current unsecured bank loans received and current portion of non-current unsecured bank loans received",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfSecuredBondsSukukLoanStocksAbstract",
      "label": "Current portion of secured bonds/sukuk/loan stocks",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfSecuredBonds",
      "label": "Bonds",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfSecuredSukukAsPerShariahCommittee",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfSecuredMediumTermNotes",
      "label": "Medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfSecuredLoanStocks",
      "label": "Loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfSecuredPreferenceShares",
      "label": "Preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfSecuredBondsSukukAndLoanStocks",
      "label": "Total current portion of secured bonds/sukuk/loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfUnsecuredBondsSukukLoanStocksAbstract",
      "label": "Current portion of unsecured bonds/sukuk/loan stocks",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfUnsecuredBonds",
      "label": "Bonds",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfUnsecuredSukukAsPerShariahCommittee",
      "label": "Sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfUnsecuredMediumTermNotes",
      "label": "Medium term notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfUnsecuredLoanStocks",
      "label": "Loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfUnsecuredPreferenceShares",
      "label": "Preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentPortionOfUnsecuredBondsSukukAndLoanStock",
      "label": "Total current portion of unsecured bonds/sukuk/loan stocks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentBorrowingsAbstract",
      "label": "Other current borrowings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPortionOfTradeLoans",
      "label": "Trade loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPortionOfLoanFromSubsidiaries",
      "label": "Loan from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPortionOfLoanFromAssociates",
      "label": "Loan from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPortionOfLoanFromJointVentures",
      "label": "Loan from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPortionOfRedeemablePreferenceShares",
      "label": "Redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPortionOfMiscellaneousBorrowings",
      "label": "Other current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherCurrentBorrowingsAndCurrentPortionOfOtherNoncurrentBorrowings",
      "label": "Total other current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermBorrowings",
      "label": "Total current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentEmployeeBenefitLiabilitiesAbstract",
      "label": "Current employee benefit liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentCashSettledShareBasedPaymentLiability",
      "label": "Cash-settled share-based payment liability",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentRetirementBenefits",
      "label": "Retirement benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentEmploymentTerminationBenefits",
      "label": "Employment termination benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentProvisionForUnconsumedLeave",
      "label": "Provision for unconsumed leave",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDefinedContributionPlan",
      "label": "Defined contribution plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDefinedBenefitPlan",
      "label": "Defined benefit plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentOtherEmployeeBenefitLiabilities",
      "label": "Other current employee benefit liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentProvisionsForEmployeeBenefits",
      "required": true,
      "label": "Total current employee benefit liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentProvisionsAbstract",
      "label": "Current provisions",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermWarrantyProvision",
      "label": "Warranty provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermRestructuringProvision",
      "label": "Restructuring provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermLegalProceedingsProvision",
      "label": "Legal proceedings provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentRefundsProvision",
      "label": "Refunds provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermOnerousContractsProvision",
      "label": "Onerous contracts provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShorttermProvisionForDecommissioningRestorationAndRehabilitationCosts",
      "label": "Provision for decommissioning, restoration and rehabilitation costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherShorttermProvisions",
      "label": "Other current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentProvisions",
      "required": true,
      "label": "Total current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:TradeAndOtherCurrentPayablesAbstract",
      "label": "Trade and other current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentTradePayablesAbstract",
      "label": "Current trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradePayablesDueToCustomers",
      "label": "Trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradePayableDueToContractCustomer",
      "label": "Trade payable due to contract suppliers",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradePayablesDueToHoldingCompany",
      "label": "Trade payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradePayablesDueToSubsidiaries",
      "label": "Trade payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradePayablesDueToAssociates",
      "label": "Trade payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradePayablesDueToJointVentures",
      "label": "Trade payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentTradePayablesDueToRelatedCompanies",
      "label": "Trade payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentTradePayables",
      "label": "Other current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:TradeAndOtherCurrentPayablesToTradeSuppliers",
      "label": "Total current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherCurrentPayablesAbstract",
      "label": "Other current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToRelatedPartiesAbstract",
      "label": "Other current payables due to related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToHoldingCompany",
      "label": "Other payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToSubsidiaries",
      "label": "Other payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToAssociates",
      "label": "Other payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToJointVentures",
      "label": "Other payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToOtherRelatedParties",
      "label": "Other payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToRelatedParties",
      "label": "Total other current payables due to related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherPayablesDueToNonControllingInterestsAbstract",
      "label": "Other payables due to non-controlling interests",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentDividendPayableToNoncontrollingInterest",
      "label": "Dividend payable to non-controlling interest",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentLoansFromNoncontrollingInterest",
      "label": "Loans from non-controlling interest",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentMiscellaneousPayableDueToNoncontrollingInterest",
      "label": "Miscellaneous payable due to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentPayablesDueToNoncontrollingInterests",
      "label": "Total other payables due to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentNontradePayablesAbstract",
      "label": "Current non-trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeAccruals",
      "label": "Accruals",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeRetentionPayable",
      "label": "Retention payable",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeDeferredIncome",
      "label": "Deferred income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeDepositsAndAdvancedBillings",
      "label": "Deposits and advanced billings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeFinancingCosts",
      "label": "Financing costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeDividendPayable",
      "label": "Dividend payable",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradeInterestPayable",
      "label": "Interest payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentNontradePayables",
      "label": "Other current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentNontradePayables",
      "label": "Total current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherCurrentPayables",
      "label": "Total other current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:TradeAndOtherCurrentPayables",
      "required": true,
      "label": "Total trade and other current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativeFinancialLiabilitiesAbstract",
      "label": "Current derivative financial liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativesAtFairValueThroughProfitOrLossAbstract",
      "label": "Current derivatives at fair value through profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesForwardContract",
      "label": "Forward contract",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesOptions",
      "label": "Options",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesSwap",
      "label": "Swap",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesOthers",
      "label": "Other derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesAtFairValueThroughProfitOrLoss",
      "label": "Total current derivatives at fair value through profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativesUsedForHedgingAbstract",
      "label": "Current derivatives used for hedging",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesForwardContractUsedForHedging",
      "label": "Forward contract",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesOptionsUsedForHedging",
      "label": "Options",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesSwapUsedForHedging",
      "label": "Swap",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesOthersUsedForHedging",
      "label": "Other derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentDerivativeFinancialLiabilitiesUsedForHedging",
      "label": "Total current derivatives used for hedging",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCurrentDerivativeFinancialLiabilities",
      "label": "Other current derivative financial liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativeFinancialLiabilities",
      "required": true,
      "label": "Total current derivative financial liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    }
  ]
}
